import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Typography, Box } from '@mui/material';
import SupportIcon from '@mui/icons-material/Support';
import toast from 'react-hot-toast';
import NavBarButton from 'src/components/NavBar/NavBarButton';

const Help = () => {
  const [open, setOpen] = useState(false);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const encodedBody = encodeURIComponent(message).replace(/%20/g, '+').replace(/%0A/g, '%0D%0A');

    const url = `https://mail.google.com/mail/?fs=1&to=abrkamalov@gmail.com&su=${encodeURIComponent(subject)}&body=${encodedBody}&tf=cm`;

    // Set window dimensions
    const height = window.screen.height * 0.8;
    const width = window.screen.width * 0.5;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    const windowFeatures = `top=${top},left=${left},width=${width},height=${height},scrollbars=yes,resizable=yes`;

    // Open Gmail in new window
    window.open(url, 'EmailWindow', windowFeatures);

    // Show success message and close dialog
    toast.success('Opening email client...');
    handleClose();
  };

  return (
    <>
      <NavBarButton label="Support" Icon={() => <SupportIcon />} isActive={false} vertical onClick={handleOpen} />
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Contact Support</DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Send us your question and we&apos;ll get back to you as soon as possible.
            </Typography>
            <TextField fullWidth label="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} required sx={{ mb: 2 }} />
            <TextField fullWidth label="Message" multiline rows={4} value={message} onChange={(e) => setMessage(e.target.value)} required />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Send Email
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Help;
